import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error-circle-filled",
  "use": "icon-error-circle-filled-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-error-circle-filled\">\n  <path d=\"M24,48A24,24,0,0,1,7.029,7.029,24,24,0,0,1,40.97,40.97,23.842,23.842,0,0,1,24,48Zm0-17a2,2,0,1,0,2,2A2,2,0,0,0,24,31Zm0-18a1.936,1.936,0,0,0-1.934,2l.383,11.5a1.551,1.551,0,0,0,3.1,0L25.934,15A1.935,1.935,0,0,0,24,13Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol